import { create } from 'zustand'
import type { UserProfile } from '../types/user.js'

interface ChatwootTokens {
  accessToken: string
  client: string
  uid: string
}

interface AuthState {
  tokens: ChatwootTokens | null
  user: UserProfile | null
  isLoading: boolean
  error: string | null
  setTokens: (tokens: ChatwootTokens) => void
  setUser: (user: UserProfile) => void
  setError: (error: string) => void
  setLoading: (loading: boolean) => void
  reset: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  tokens: null,
  user: null,
  isLoading: false,
  error: null,
  setTokens: (tokens) => set({ tokens, isLoading: true, error: null }),
  setUser: (user) => set({ user, isLoading: false, error: null }),
  setError: (error) => set({ error, isLoading: false }),
  setLoading: (isLoading) => set({ isLoading }),
  reset: () => set({ tokens: null, user: null, isLoading: false, error: null }),
}))
